export default "__VITE_ASSET__no4gn_z4__"